<router-outlet *ngIf="styles"></router-outlet>
<div id="toast-container" toastContainer></div>
<div *ngIf="loader" class="gray-overlay">
  <div id="loader-overlay">
    <div id="loader">
      <img src="../assets/icons/loaderTransparent.gif" class="loader-gif" />
    </div>
  </div>
</div>
